import { colors, radius, shadows } from "../data/tokens";

// ============================================================
// Estilos das listas no padrão do painel (Categorias, Itens de
// Cobrança, Eleições…): busca, tabela e paginação dentro de um
// único cartão branco, cabeçalho compacto em caixa-alta.
// ============================================================

const cardMain = {
  backgroundColor: colors.white,
  borderRadius: `${radius.lg}px`,
  boxShadow: shadows.card,
  padding: "12px 20px 8px",
};

// Lista sem toolbar (telas de poucos itens fixos)
export const listCardSx = {
  "& .RaList-main": cardMain,
  "& .RaList-content": {
    boxShadow: "none",
    backgroundColor: "transparent",
  },
};

// Lista com busca à esquerda e ações à direita, na mesma linha
// (anula os hacks antigos do App.css que posicionavam a toolbar)
export const listCardWithToolbarSx = {
  ...listCardSx,
  "& .RaList-main": { ...cardMain, padding: "4px 20px 8px" },
  "& .RaList-actions": { alignItems: "center" },
  "& .RaList-actions .MuiToolbar-root": {
    position: "static",
    gap: 1,
  },
  "& .RaFilterForm-filterFormInput": { marginTop: 0 },
};

export const datagridSx = {
  "& .RaDatagrid-headerCell": {
    fontSize: 11.5,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: colors.textMuted,
    backgroundColor: colors.bgSubtle,
    paddingTop: 1,
    paddingBottom: 1,
  },
  "& .RaDatagrid-rowCell": { paddingTop: 0.75, paddingBottom: 0.75 },
};

// Texto principal da linha (nome do registro)
export const rowTitleSx = {
  fontSize: 13.5,
  fontWeight: 600,
  color: colors.primaryDark,
};

// Rótulo de campo nas fichas de leitura
export const showLabelSx = {
  fontSize: 11,
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  color: colors.textMuted,
};
